import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "locale": {
      "column": {
        "default": null,
        "name": "locale",
        "null": false,
        "type": "string"
      },
      "name": "locale",
      "selected_by_default": null,
      "translated": null
    },
    "text_key_id": {
      "column": {
        "default": null,
        "name": "text_key_id",
        "null": false,
        "type": null
      },
      "name": "text_key_id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "value": {
      "column": {
        "default": null,
        "name": "value",
        "null": true,
        "type": "text"
      },
      "name": "value",
      "selected_by_default": null,
      "translated": null
    },
    "value_type": {
      "column": {
        "default": "plain",
        "name": "value_type",
        "null": false,
        "type": "string"
      },
      "name": "value_type",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "TextValue",
  "collectionKey": "text_values",
  "collectionName": "text_values",
  "i18nKey": "text_value",
  "camelizedLower": "textValue",
  "name": "TextValue",
  "nameDasherized": "text-value",
  "pluralName": "text_values",
  "ransackable_associations": [
    {
      "className": "TextValue::Audit",
      "collectionName": "text_value_audits",
      "foreignKey": "text_value_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "TextValueAudit",
      "through": null
    },
    {
      "className": "TextValue::Audit",
      "collectionName": "text_value_audits",
      "foreignKey": "text_value_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "TextValueAudit",
      "through": null
    },
    {
      "className": "TextKey",
      "collectionName": "text_keys",
      "foreignKey": "text_key_id",
      "name": "text_key",
      "macro": "belongs_to",
      "resource_name": "TextKey",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "locale",
      "column": {
        "default": null,
        "name": "locale",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "text_key_id",
      "column": {
        "default": null,
        "name": "text_key_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "value",
      "column": {
        "default": null,
        "name": "value",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "value_type",
      "column": {
        "default": "plain",
        "name": "value_type",
        "null": false,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [],
  "paramKey": "text_value",
  "primaryKey": "id"
}

/** Frontend model for TextValue. */
class TextValue extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  locale() {
    return this.readAttributeUnderscore("locale")
  }

  /** @returns {boolean} */
  hasLocale() {
    const value = this.locale()

    return this._isPresent(value)
  }

  /** @returns {any} */
  textKeyId() {
    return this.readAttributeUnderscore("text_key_id")
  }

  /** @returns {boolean} */
  hasTextKeyId() {
    const value = this.textKeyId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  value() {
    return this.readAttributeUnderscore("value")
  }

  /** @returns {boolean} */
  hasValue() {
    const value = this.value()

    return this._isPresent(value)
  }

  /** @returns {string} */
  valueType() {
    return this.readAttributeUnderscore("value_type")
  }

  /** @returns {boolean} */
  hasValueType() {
    const value = this.valueType()

    return this._isPresent(value)
  }
}

export default TextValue
